import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Page from "../../components/Page";
import {
  Table,
  Breadcrumb,
  Segment,
  Button,
  Modal,
  Form,
  Loader,
  Dimmer,
  Radio,
  Icon,Label,Message
} from "semantic-ui-react";
import _ from "lodash";
import { post } from '../../util/api'

const QuestionAnswer = () => {
  const { t } = useTranslation();
  const product = useSelector(state => state.product);
  const pid = product.personalize.id;
  const [questions, setQuestions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(true);
  const [sortColumn, setSortColumn] = useState('created_at');
  const [sortDirection, setSortDirection] = useState('descending');
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [filterVerify, setFilterVerify] = useState(null);
  const [filterEmailSent, setFilterEmailSent] = useState(null);
  const [bulkEmailSending, setBulkEmailSending] = useState(false);
  const [emailSendingStatus, setEmailSendingStatus] = useState('idle');
  const preferredMailServiceFrontend = product.personalize.settings.questionAnswerData.preferredMailService

  const handleSendEmail = async (question) => {
  if (question.pid === "9aa91e95-413a-4659-88f8-44eb6c6430d2") {
     setEmailSendingStatus('loading');
     try {
         const payload = {
             pid: pid,
             productName: question.extra.productName,
             productBrand: question.extra.productBrand,
             productImage: question.extra.productImage,
             name_firm: question.extra.name_firm,
             user_email: question.extra.user_email,
             user_id: question.extra.user_id,
             user_name: question.extra.user_name,
             product_link: question.extra.product_link,
             question: question.extra.question,
             answer: question.extra.answer.text
         };

         const response = await fetch("https://log.collectaction.com/api/emarsys-trigger-email", {
             method: "POST",
             headers: {
                 "Content-Type": "application/json"
             },
             body: JSON.stringify(payload)
         });

         const data = await response.json();

         if (response.ok && data.success) {
             try {
                 const updatedExtra = {
                     ...question.extra,
                     emailSent: true
                 };
                 await post("/personalize/question", {
                     id: question.id,
                     pid: question.pid,
                     extra: updatedExtra
                 });
             } catch (updateError) {
                 console.error("Failed to update question status:", updateError);
             }

             setEmailSendingStatus('sent');
             setTimeout(() => setEmailSendingStatus('idle'), 3000);
             await fetchQuestionAnswer();
         } else {
             console.error("Backend Error:", data);
             setEmailSendingStatus('error');
             setTimeout(() => setEmailSendingStatus('idle'), 3000);
         }

     } catch (error) {
         console.error("API Call Error:", error);
         setEmailSendingStatus('error');
         setTimeout(() => setEmailSendingStatus('idle'), 3000);
     }
     return;
 }

    setEmailSendingStatus('loading');
    try {
      const mailTemplate = product.personalize.settings.questionAnswerData.mailTemplate;
      const smtpSettings = product.personalize.settings.questionAnswerData.smtpSettings;
      
      // Template içindeki değişkenleri doldur
      let emailContent = mailTemplate;
      const templateData = {
        name: question.extra.user_name,
        question: question.extra.question,
        answer: question.extra.answer.text,
        productlink:question.extra.product_link
      };

  
      for (const [key, value] of Object.entries(templateData)) {
        emailContent = emailContent.replace(new RegExp(`{{${key}}}`, 'g'), value);
      }
  
      const response = await post("/personalize/sendEmail", {
        pid: question.pid,
        questionId: question.id,
        recipientEmail: question.extra.user_email,
        emailContent: emailContent,
        smtpSettings: smtpSettings,
        preferredMailService: preferredMailServiceFrontend
      });
  
      if (response.data.success) {
        setEmailSendingStatus('sent');
        setTimeout(() => setEmailSendingStatus('idle'), 3000);
        await fetchQuestionAnswer();
      } else {
        setEmailSendingStatus('error');
        setTimeout(() => setEmailSendingStatus('idle'), 3000);
      }
    } catch (error) {
      console.error("E-posta gönderimi sırasında hata oluştu:", error);
      setEmailSendingStatus('error');
    }finally {
      setTimeout(() => setEmailSendingStatus('idle'), 3000);
    }
  };

  const handleBulkSendEmail = async () => {
    setBulkEmailSending(true);
    try {
      const unsentQuestions = filteredQuestions.filter(question => !question.extra?.emailSent);      
      for (const question of unsentQuestions) {
        if (question.extra?.answer && question.extra?.answer.text) {
          try {
            await handleSendEmail(question);
            await new Promise(resolve => setTimeout(resolve, 1000));
          } catch (error) {
            console.error(`Soru ID ${question.id} için e-posta gönderilemedi:`, error);
          }
        }
      }
      await fetchQuestionAnswer();
    } catch (error) {
      console.error('Toplu e-posta gönderimi sırasında hata oluştu:', error);
    } finally {
      setBulkEmailSending(false);
    }
  };
  
  const handleSort = (clickedColumn) => {
    if (sortColumn !== clickedColumn) {
      setSortColumn(clickedColumn);
      setSortDirection('ascending');
      setQuestions(_.sortBy(questions, [clickedColumn]));
      return;
    }
  
    setQuestions(questions.reverse());
    setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
  };
  
  
  const handleDateRangeChange = (start, end) => {
    setDateRange({ start, end });
  };
  
  const handleVerifyFilter = (value) => {
    setFilterVerify(value);
  };
  
  const handleEmailSentFilter = (value) => {
    setFilterEmailSent(value);
  };
  
  const filteredQuestions = questions.filter((question) => {
    const matchesDateRange = (!dateRange.start || new Date(question.created_at) >= dateRange.start) &&
                             (!dateRange.end || new Date(question.created_at) <= dateRange.end);
    
    const matchesVerify = filterVerify === null || question.verify === filterVerify;
    const matchesEmailSent = filterEmailSent === null || Boolean(question.extra.emailSent) === filterEmailSent;
  
    return matchesDateRange && matchesVerify && matchesEmailSent;
  });

  useEffect(() => {
    fetchQuestionAnswer();
  }, [pid]);

  const fetchQuestionAnswer = async () => {
    setLoading(true);
    try {
      const res = await post("/personalize/question", { pid });
      //console.log("dene",res)
      if (res.data && res.data.success && Array.isArray(res.data.result)) {
        const sortedQuestions = _.orderBy(res.data.result, ['created_at'], ['desc']);
        setQuestions(sortedQuestions);
      } else {
        console.error("Unexpected API response:", res);
      }
    } catch (error) {
      console.error('Veri çekilirken hata oluştu:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAnswerSubmit = async () => {
    setLoading(true);
    try {
      await post("/personalize/answer", {
        id: currentQuestion.id,
        pid: currentQuestion.pid,
        answer: answer
      });
      await fetchQuestionAnswer(); // Yeni veriyi çek
    } catch (error) {
      console.error('Cevap gönderilirken hata oluştu:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyToggle = async (question) => {
    try {
      const response = await post("/personalize/updateQuestionVerify", {
        id: question.id,
        pid: question.pid,
        verify: !question.verify
      });
      if (response.data && response.data.success) {
  
        setQuestions(prevQuestions => 
          prevQuestions.map(q => 
            q.id === question.id ? {...q, verify: !q.verify} : q
          )
        );
      } else {
        console.error("Soru güncellenemedi:", response.data.message);
      }
    } catch (error) {
      console.error('Soru güncellenirken hata oluştu:', error);
    }
  };

  const openAnswerModal = (question) => {
    setCurrentQuestion(question);
    setAnswer(question.extra.answer ? question.extra.answer.text : "");
    setModalOpen(true);
  };
  return (
    <Page
      icon="chart line"
      title={t("qaQuestionAnswerModule")}
      header={
        <Breadcrumb size="big">
          <Breadcrumb.Section>{t("qaQuestionAnswerModule")}</Breadcrumb.Section>
        </Breadcrumb>
      }
    >
      <Page.Wrap>
        <Segment>
          <Dimmer active={loading} inverted>
            <Loader>{t("qaLoading")}</Loader>
          </Dimmer>
          <Label ribbon>
            {t("qaPreferredMailMethod")}{" "}
            {preferredMailServiceFrontend === "sendinblue"
              ? t("qaSendinblue")
              : t("qaSmtp")}
          </Label>
          <Form>
            <Form.Group widths="equal">
              <Form.Field>
                <label>{t("qaStartDate")}</label>
                <Form.Input
                  type="date"
                  onChange={(e) =>
                    handleDateRangeChange(
                      new Date(e.target.value),
                      dateRange.end
                    )
                  }
                />
              </Form.Field>
              <Form.Field>
                <label>{t("qaEndDate")}</label>
                <Form.Input
                  type="date"
                  onChange={(e) =>
                    handleDateRangeChange(
                      dateRange.start,
                      new Date(e.target.value)
                    )
                  }
                />
              </Form.Field>
              <Form.Field>
                <label>{t("qaApprovalStatus")}</label>
                <Form.Select
                  fluid
                  options={[
                    { key: "all", text: t("qaAll"), value: null },
                    { key: "verified", text: t("qaApproved"), value: true },
                    { key: "unverified", text: t("qaNotApproved"), value: false },
                  ]}
                  placeholder={t("qaSelect")}
                  onChange={(e, { value }) => handleVerifyFilter(value)}
                />
              </Form.Field>
              <Form.Field>
                <label>{t("qaEmailStatus")}</label>
                <Form.Select
                  fluid
                  options={[
                    { key: "all", text: t("qaAll"), value: null },
                    { key: "sent", text: t("qaEmailSent"), value: true },
                    { key: "not_sent", text: t("qaEmailNotSentYet"), value: false },
                  ]}
                  placeholder={t("qaSelect")}
                  onChange={(e, { value }) => handleEmailSentFilter(value)}
                />
              </Form.Field>
            </Form.Group>
          </Form>
          
          {/* Toplu E-posta Gönder Butonu - Sadece e-posta gönderilmemiş filtresi seçildiğinde göster */}
          {filterEmailSent === false && (
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
              <Button
                primary
                size="large"
                onClick={handleBulkSendEmail}
                loading={bulkEmailSending}
                disabled={bulkEmailSending || filteredQuestions.filter(q => !q.extra?.emailSent && q.extra?.answer && q.extra?.answer.text).length === 0}
                icon="mail"
                content={bulkEmailSending ? t("qaSending") : "Toplu E-Posta Gönder"}
              />
              <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                {filteredQuestions.filter(q => !q.extra?.emailSent && q.extra?.answer && q.extra?.answer.text).length} adet cevapı olan soruya e-posta gönderilecek
              </div>
            </div>
          )}
          
          <Table celled sortable fixed compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  width={1}
                  sorted={sortColumn === "product_id" ? sortDirection : null}
                  onClick={() => handleSort("product_id")}
                >
                  {t("qaProductID")}
                </Table.HeaderCell>
                <Table.HeaderCell width={1}>{t("qaEmailStatus")}</Table.HeaderCell>
                <Table.HeaderCell width={3}>{t("qaProductLink")}</Table.HeaderCell>
                <Table.HeaderCell
                  sorted={
                    sortColumn === "extra.user_email" ? sortDirection : null
                  }
                  onClick={() => handleSort("extra.user_email")}
                >
                  {t("qaCustomerEmail")}
                </Table.HeaderCell>
                <Table.HeaderCell
                  sorted={sortColumn === "created_at" ? sortDirection : null}
                  onClick={() => handleSort("created_at")}
                >
                  {t("qaCreationDate")}
                </Table.HeaderCell>
                <Table.HeaderCell>{t("qaQuestionContent")}</Table.HeaderCell>
                <Table.HeaderCell
                  width={1}
                  sorted={sortColumn === "verify" ? sortDirection : null}
                  onClick={() => handleSort("verify")}
                >
                  {t("qaApproval")}
                </Table.HeaderCell>
                <Table.HeaderCell>{t("qaAnswer")}</Table.HeaderCell>
                <Table.HeaderCell>{t("qaAction")}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!loading && filteredQuestions.length === 0 ? (
                <Table.Row>
                  <Table.Cell colSpan="8">{t("qaNoQuestionsFound")}</Table.Cell>
                </Table.Row>
              ) : (
                filteredQuestions.map((question) => (
                  <Table.Row key={question.id}>
                    <Table.Cell>{question.product_id}</Table.Cell>
                    <Table.Cell textAlign="center">
                      {question.extra.emailSent ? (
                        <Icon
                          name="check circle"
                          color="green"
                          size="large"
                          title={t("qaEmailSent")}
                        />
                      ) : (
                        <Icon
                          name="mail outline"
                          color="grey"
                          size="large"
                          title={t("qaEmailNotSentYet")}
                        />
                      )}
                    </Table.Cell>
                    <Table.Cell
                      style={{ wordBreak: "break-all", whiteSpace: "normal" }}
                    >
                      {question.extra.product_link}
                    </Table.Cell>
                    <Table.Cell style={{ wordBreak: "break-word" }}>
                      {question.extra.user_email}
                    </Table.Cell>
                    <Table.Cell>
                      {new Date(question.created_at).toLocaleString()}
                    </Table.Cell>
                    <Table.Cell>{question.extra.question}</Table.Cell>
                    <Table.Cell>
                      <Radio
                        toggle
                        checked={question.verify}
                        onChange={() => handleVerifyToggle(question)}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      {question.extra.answer
                        ? question.extra.answer.text
                        : t("qaNotAnsweredYet")}
                    </Table.Cell>
                    <Table.Cell>
                      <Button onClick={() => openAnswerModal(question)}>
                        {question.extra.answer ? t("qaEdit") : t("qaReply")}
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                ))
              )}
            </Table.Body>
          </Table>
        </Segment>
      </Page.Wrap>
      <Modal closeIcon open={modalOpen} onClose={() => setModalOpen(false)}>
        <Modal.Header>{t("qaAnswerQuestion")}</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field>
              <label>{t("qaQuestion")}</label>
              <p>{currentQuestion?.extra.question}</p>
            </Form.Field>
            <Form.Field>
              <label>{t("qaAnswer")}</label>
              <Form.TextArea
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                placeholder={t("qaWriteYourAnswerHere")}
              />
            </Form.Field>
          </Form>
          <Message
            icon="save"
            header={t("qaImportantReminder")}
            content={t("qaSaveReminderMessage")}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            onClick={() => setModalOpen(false)}
            disabled={loading}
            icon="cancel"
            content={t("qaCancel")}
          />
          <Button
            positive
            onClick={handleAnswerSubmit}
            loading={loading}
            disabled={loading}
            icon="save"
            content={t("qaSave")}
          />
          <Button
            primary
            onClick={() => handleSendEmail(currentQuestion)}
            disabled={
              !currentQuestion?.extra.answer ||
              loading ||
              emailSendingStatus !== "idle"
            }
            icon={emailSendingStatus === "loading" ? "spinner" : "mail"}
            loading={emailSendingStatus === "loading"}
            content={
              emailSendingStatus === "idle"
                ? t("qaSendEmail")
                : emailSendingStatus === "loading"
                ? t("qaSending")
                : emailSendingStatus === "sent"
                ? t("qaSent")
                : t("qaError")
            }
          />
        </Modal.Actions>
      </Modal>
    </Page>
  );

};

export default QuestionAnswer;